<div class="modal inmodal fade in create-modal parcel-modal create-edit-parcel-modal instruction-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal(form)">
                        <span>×</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">
                        {{instructionType == 'entry_instruction' ? 'Entry' : 'Vacation'}} Instructions
                    </h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Instruction Type ___ -->
                    <div class="row m-b-sm long-date-field" *ngIf="authenticationService.userIsResident" >
                        <div class="col-md-4">
                            <label>Instruction Type</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control" name="type" [(ngModel)]="instructionType" required>
                                <option [value]="'entry_instruction'" selected>Entry Instruction</option>
                                <option [value]="'vacation_instruction'">Vacation Instruction</option>
                            </select>
                        </div>
                    </div>
                    <!-- ___ Start Date ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-4">
                            <label>Start Date</label>
                        </div>
                        <mat-form-field class="col-md-8">
                            <input matInput [(ngModel)]="startDate" name="startDate" [matDatepicker]="startPicker"
                                   (focus)="startPicker.open()" (click)="startPicker.open()"
                                   (ngModelChange)="onStartDateChange()" placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- ___ End Date ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-4">
                            <label>End Date</label>
                        </div>
                        <mat-form-field class="col-md-8">
                            <input matInput [(ngModel)]="endDate" [min]="startDate" name="endDate"
                                   (ngModelChange)="onEndDateChange($event)"
                                   (focus)="endPicker.open()" (click)="endPicker.open()"
                                   [matDatepicker]="endPicker" placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!--  ** Subject **  -->
                    <div class="row m-b-xs">
                        <div class="col-sm-4">
                            <label>Subject</label>
                        </div>
                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control" name="subject" [(ngModel)]="subject" required maxlength="255">
                        </div>
                    </div>

                    <!-- ___ Instructions ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Instructions</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <textarea class="form-control" name="instructions" [(ngModel)]="instructions" required></textarea>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal(form)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/add-instructions-modal/add-instructions-modal.component.html